import { temporaryOrderDomainStore } from '../../temporary-store/store';
export const orderHasInProgressAction = () => {
    return temporaryOrderDomainStore.data.inProgressActions.size > 0;
};
